import { createAction, props } from '@ngrx/store';
import { Lot } from 'src/app/components/bids-and-offers/lots.model';
import { NegotiationDetails } from 'src/app/components/negotiations/negotiations.model';

export const selectLot = createAction(
  '[Lot] Select Lot',
  props<{ lotDetails: Lot }>()
);
export const lotNegotiationData = createAction(
  '[Lot] Negotiation Data',
  props<{ negotiations: NegotiationDetails[] }>()
);
